import React from 'react';
import { useNavigate } from 'react-router-dom';

const CopyrightDMCA = () => {
  const navigate = useNavigate();
  
  return (
    <div>
      {/* Back to Home Button */}
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        padding: '20px 20px 0 20px'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: '#2563eb',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            fontSize: '0.95rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          onMouseOver={(e) => e.target.style.background = '#1d4ed8'}
          onMouseOut={(e) => e.target.style.background = '#2563eb'}
        >
          <span>←</span> Back to Home
        </button>
      </div>
      
      <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>Copyright & DMCA Notice</h1>
      <p style={{ color: '#666', marginBottom: '40px' }}><strong>Effective Date:</strong> January 1, 2025</p>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Copyright Policy</h2>
        <p>All content, features, and functionality on SmartPDF Tools ("the Service"), including but not limited to text, graphics, logos, icons, images, software, and the compilation thereof, are the exclusive property of SmartPDF Tools or its content suppliers and are protected by international copyright laws.</p>
        <p style={{ marginTop: '15px' }}>The Service and its original content, features, and functionality are owned by SmartPDF Tools and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>User-Generated Content</h2>
        <p>You retain all rights to any content you submit, upload, or display on or through the Service. By uploading content, you grant SmartPDF Tools a worldwide, non-exclusive, royalty-free license to use, reproduce, process, and display your content solely for the purpose of providing the Service to you.</p>
        <p style={{ marginTop: '15px' }}><strong>Important:</strong> We do not claim ownership of your files. All uploaded PDFs and generated files are processed temporarily and are not stored permanently on our servers. Files are automatically deleted after processing.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>DMCA Compliance</h2>
        <p>SmartPDF Tools respects the intellectual property rights of others and expects users to do the same. In accordance with the Digital Millennium Copyright Act (DMCA), we will respond to valid notices of alleged copyright infringement that comply with the DMCA and other applicable laws.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Filing a DMCA Notice</h2>
        <p>If you believe that your copyrighted work has been copied in a way that constitutes copyright infringement and is accessible via the Service, please notify our copyright agent as set forth below. For your complaint to be valid under the DMCA, you must provide the following information in writing:</p>
        <ol style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li style={{ marginBottom: '10px' }}>An electronic or physical signature of the copyright owner or a person authorized to act on their behalf;</li>
          <li style={{ marginBottom: '10px' }}>Identification of the copyrighted work claimed to have been infringed;</li>
          <li style={{ marginBottom: '10px' }}>Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate the material;</li>
          <li style={{ marginBottom: '10px' }}>Your contact information, including your address, telephone number, and an email address;</li>
          <li style={{ marginBottom: '10px' }}>A statement by you that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law;</li>
          <li style={{ marginBottom: '10px' }}>A statement that the information in the notification is accurate, and, under penalty of perjury, that you are authorized to act on behalf of the copyright owner.</li>
        </ol>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>DMCA Contact Information</h2>
        <div style={{ background: '#f3f4f6', padding: '20px', borderRadius: '8px', marginTop: '15px' }}>
          <p><strong>Copyright Agent:</strong> Legal Department</p>
          <p><strong>Email:</strong> <a href="mailto:support@smrtpdftools.com" className="text-blue-600 hover:text-blue-700">support@smrtpdftools.com</a></p>
          <p><strong>Address:</strong> SmartPDF Tools Legal Department<br/>123 PDF Street<br/>Suite 100<br/>San Francisco, CA 94102<br/>United States</p>
        </div>
        <p style={{ marginTop: '15px', fontSize: '0.95rem', color: '#666' }}>Please allow up to 5-7 business days for an email response. Note that emailing your complaint to parties other than our designated agent may result in a delay in processing your complaint.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Counter-Notification</h2>
        <p>If you believe that your content that was removed (or to which access was disabled) is not infringing, or that you have the authorization from the copyright owner, the copyright owner's agent, or pursuant to the law, to post and use the material, you may send a counter-notice containing the following information to our copyright agent:</p>
        <ol style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li style={{ marginBottom: '10px' }}>Your physical or electronic signature;</li>
          <li style={{ marginBottom: '10px' }}>Identification of the content that has been removed or to which access has been disabled and the location at which the content appeared before it was removed or disabled;</li>
          <li style={{ marginBottom: '10px' }}>A statement that you have a good faith belief that the content was removed or disabled as a result of mistake or a misidentification of the content; and</li>
          <li style={{ marginBottom: '10px' }}>Your name, address, telephone number, and email address, and a statement that you consent to the jurisdiction of the federal court in San Francisco, California, and that you will accept service of process from the person who provided notification of the alleged infringement.</li>
        </ol>
        <p style={{ marginTop: '15px' }}>If a counter-notice is received, we may send a copy of the counter-notice to the original complaining party informing that person that we may replace the removed content or cease disabling it in 10 business days. Unless the copyright owner files an action seeking a court order against the content provider, the removed content may be replaced, or access to it restored, in 10 to 14 business days or more after receipt of the counter-notice.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Repeat Infringer Policy</h2>
        <p>In accordance with the DMCA and other applicable laws, SmartPDF Tools has adopted a policy of terminating, in appropriate circumstances and at our sole discretion, users who are deemed to be repeat infringers. We may also, at our sole discretion, limit access to the Service and/or terminate the accounts of any users who infringe any intellectual property rights of others, whether or not there is any repeat infringement.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Changes to This Policy</h2>
        <p>We reserve the right to update or modify this Copyright & DMCA Notice at any time without prior notice. Your continued use of the Service after any such changes constitutes your acceptance of the new policy.</p>
      </section>

      <div style={{ marginTop: '40px', padding: '20px', background: '#f9fafb', borderLeft: '4px solid #2563eb', borderRadius: '4px' }}>
        <p style={{ margin: 0, fontSize: '0.95rem' }}>
          <strong>Questions?</strong> If you have any questions about this Copyright & DMCA Notice, please contact us at <a href="mailto:support@smrtpdftools.com" className="text-blue-600 hover:text-blue-700">support@smrtpdftools.com</a>
        </p>
      </div>
    </div>
    </div>
  );
};

export default CopyrightDMCA;